module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_location_sola_3column@3x-7a67c54deecff89412ca49a3228800d8.webp";